import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, AlertTriangle, CheckCircle } from 'lucide-react';
import api from '../../api/client';

export default function OpacMyPage() {
  const [user, setUser] = useState<any>(null);
  const [checkouts, setCheckouts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const u = localStorage.getItem('opac_user');
    const t = localStorage.getItem('opac_token');
    if (!u || !t) { window.location.href = '/opac/login'; return; }
    setUser(JSON.parse(u));

    api.get('/checkouts?status=active&limit=20')
      .then((res: any) => setCheckouts(res.data?.checkouts || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{padding:48,textAlign:'center',color:'#475569'}}>იტვირთება...</div>;
  if (!user) return null;

  const overdueList = checkouts.filter((c: any) => new Date(c.due_date) < new Date());
  const activeList = checkouts.filter((c: any) => new Date(c.due_date) >= new Date());

  return (
    <div style={{paddingTop:24,paddingBottom:48}}>
      <div style={{display:'flex',alignItems:'center',gap:16,marginBottom:24,padding:20,background:'#0d1424',border:'1px solid #1e2d45',borderRadius:12}}>
        <div style={{width:56,height:56,borderRadius:14,background:'#0f2044',border:'1px solid #1e3a6e',display:'flex',alignItems:'center',justifyContent:'center',fontSize:22,fontWeight:700,color:'#60a5fa'}}>
          {(user.full_name?.[0]||'?').toUpperCase()}
        </div>
        <div>
          <div style={{fontSize:18,fontWeight:600,color:'#f1f5f9'}}>{user.full_name}</div>
          <div style={{fontSize:13,color:'#475569'}}>@{user.username}</div>
        </div>
        <div style={{marginLeft:'auto',display:'flex',gap:16}}>
          <div style={{textAlign:'center'}}>
            <div style={{fontSize:20,fontWeight:700,color:'#fbbf24'}}>{checkouts.length}</div>
            <div style={{fontSize:11,color:'#475569'}}>გაცემული</div>
          </div>
          <div style={{textAlign:'center'}}>
            <div style={{fontSize:20,fontWeight:700,color:'#f87171'}}>{overdueList.length}</div>
            <div style={{fontSize:11,color:'#475569'}}>ვადაგადაც.</div>
          </div>
        </div>
        <button onClick={() => { localStorage.removeItem('opac_token'); localStorage.removeItem('opac_user'); window.location.href='/opac'; }}
          style={{padding:'7px 14px',background:'#2d0a0a',border:'1px solid #5a1a1a',borderRadius:8,fontSize:12,color:'#f87171',cursor:'pointer'}}>
          გასვლა
        </button>
      </div>

      {overdueList.length > 0 && (
        <div style={{background:'#2d0a0a',border:'1px solid #5a1a1a',borderRadius:10,padding:14,marginBottom:20,display:'flex',alignItems:'center',gap:10}}>
          <AlertTriangle size={18} style={{color:'#f87171',flexShrink:0}} />
          <div>
            <div style={{fontSize:13,fontWeight:500,color:'#f87171'}}>გაფრთხილება!</div>
            <div style={{fontSize:12,color:'#94a3b8',marginTop:2}}>გაქვს {overdueList.length} ვადაგადაცილებული წიგნი.</div>
          </div>
        </div>
      )}

      <div style={{background:'#0d1424',border:'1px solid #1e2d45',borderRadius:12,overflow:'hidden',marginBottom:16}}>
        <div style={{padding:'14px 16px',borderBottom:'1px solid #1e2d45',display:'flex',alignItems:'center',gap:8}}>
          <BookOpen size={15} style={{color:'#fbbf24'}} />
          <span style={{fontSize:14,fontWeight:500,color:'#cbd5e1'}}>ჩემი გაცემები ({checkouts.length})</span>
        </div>
        {checkouts.length === 0 && (
          <div style={{padding:32,textAlign:'center'}}>
            <CheckCircle size={32} style={{color:'#34d399',margin:'0 auto 8px',display:'block'}} />
            <p style={{color:'#475569',fontSize:13}}>გაცემული წიგნი არ გაქვს</p>
          </div>
        )}
        {[...overdueList, ...activeList].map((c: any) => {
          const isOverdue = new Date(c.due_date) < new Date();
          return (
            <div key={c.id} style={{display:'flex',alignItems:'center',gap:12,padding:'12px 16px',borderBottom:'1px solid #0f1826'}}>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:14,fontWeight:500,color:'#cbd5e1',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{c.title}</div>
                <div style={{fontSize:12,color:'#475569',marginTop:2}}>{c.author}</div>
              </div>
              <div style={{textAlign:'right',flexShrink:0}}>
                <div style={{fontSize:12,color:'#475569'}}>{new Date(c.checked_out_at).toLocaleDateString('ka-GE')}</div>
                <div style={{fontSize:12,fontWeight:500,color:isOverdue?'#f87171':'#64748b',marginTop:2}}>
                  {isOverdue?'⚠ ':'↩ '}{new Date(c.due_date).toLocaleDateString('ka-GE')}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div style={{textAlign:'center'}}>
        <Link to="/opac/catalog" style={{display:'inline-flex',alignItems:'center',gap:6,padding:'10px 20px',background:'#1d4ed8',borderRadius:8,color:'white',textDecoration:'none',fontSize:14}}>
          <BookOpen size={16}/> კატალოგი
        </Link>
      </div>
    </div>
  );
}
